import React from 'react';
import { render } from 'react-dom';
import { Router, useRouterHistory } from 'react-router';
import { createHistory } from 'history';

import '../css/app.scss';

import humanRoutes from './human/humanRoutes';
import courseRoutes from './course/courseRoutes';
import horseRoutes from './horse/horseRoutes';

import rpLibs from './rpLibs';
import analyticsPage from './analyticsPage';

rpLibs.beforeRender();

const routes = [...humanRoutes, courseRoutes, horseRoutes];

const browserHistory = useRouterHistory(createHistory)({
    basename: '/profile/',
});

render(
    <Router routes={routes} history={browserHistory} onUpdate={() => { analyticsPage(); }} />,
    document.querySelector('main')
);

rpLibs.afterRender();


export { browserHistory as default };



// WEBPACK FOOTER //
// ./src/js/index.jsx